import { HttpApiSchema } from "@effect/platform";
import { Schema } from "effect";

export class DatabaseError extends Schema.TaggedError<DatabaseError>()(
  "DatabaseError",
  { message: Schema.optional(Schema.String) },
  HttpApiSchema.annotations({ status: 500 }),
) {}

export class DataIntegrityError extends Schema.TaggedError<DataIntegrityError>()(
  "DataIntegrityError",
  { message: Schema.optional(Schema.String) },
  HttpApiSchema.annotations({ status: 500 }),
) {}

export class OpenSearchError extends Schema.TaggedError<OpenSearchError>()(
  "OpenSearchError",
  { message: Schema.optional(Schema.String) },
  HttpApiSchema.annotations({ status: 500 }),
) {}

/**
 * The search query expanded into more clauses than the search engine allows
 * (e.g. an over-long free-text phrase that overruns Lucene's `maxClauseCount`).
 * This is a problem with the user's input, not the server, so it is a 400 the UI
 * can explain ("your search is too long") rather than a 500.
 */
export class SearchQueryTooComplexError extends Schema.TaggedError<SearchQueryTooComplexError>()(
  "SearchQueryTooComplexError",
  { message: Schema.optional(Schema.String) },
  HttpApiSchema.annotations({ status: 400 }),
) {}
